// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__32QxM","title":"ClientReferral_title__2TQGy","itemText":"ClientReferral_itemText__2YnHo"};